/* ============================================================
   Pialu — Features "2026 junio updates" (JS compartido)
   - Informaciones: tabs horizontales (req 3a)
   (La wishlist y otros comportamientos se agregan aquí más adelante.)
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Informaciones: tabs horizontales ---------- */
  function initInformaciones(root) {
    var scope = root || document;
    var widgets = scope.querySelectorAll('.informaciones[data-layout="tabs"]');
    widgets.forEach(function (el) {
      if (el.dataset.infInit === '1') return;
      el.dataset.infInit = '1';

      var btns = Array.prototype.slice.call(el.querySelectorAll('.informaciones__nav-btn'));
      var panels = Array.prototype.slice.call(el.querySelectorAll('.informaciones__panel'));
      if (!btns.length || !panels.length) return;

      function activate(target) {
        btns.forEach(function (b) {
          b.setAttribute('aria-selected', b.dataset.tabTarget === target ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          if (p.dataset.tabIndex === target) {
            p.removeAttribute('hidden');
          } else {
            p.setAttribute('hidden', '');
          }
        });
      }

      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          activate(b.dataset.tabTarget);
        });
      });

      // Estado inicial: la primera (o la marcada aria-selected)
      var selected = el.querySelector('.informaciones__nav-btn[aria-selected="true"]');
      activate(selected ? selected.dataset.tabTarget : (btns[0] && btns[0].dataset.tabTarget));
    });
  }

  /* ---------- Informaciones: acordeón vertical de apertura única (cierra las demás) ---------- */
  function bindAccordionSingleOpen() {
    if (window.__pialuInfAccordionBound) return;
    window.__pialuInfAccordionBound = true;
    document.addEventListener('click', function (e) {
      var label = e.target.closest('.informaciones[data-layout="accordion"] .accordion__label');
      if (!label || label.__infAutoClosing) return;
      var container = label.closest('.informaciones[data-layout="accordion"]');
      if (!container) return;
      // Tras el toggle nativo del tema: si ESTA quedó abierta, cierra las demás abiertas.
      setTimeout(function () {
        if (label.getAttribute('aria-expanded') !== 'true') return;
        var labels = container.querySelectorAll('.accordion__label');
        Array.prototype.forEach.call(labels, function (other) {
          if (other === label || other.getAttribute('aria-expanded') !== 'true') return;
          other.__infAutoClosing = true;
          other.click(); // dispara el cierre nativo (slideUp) del tema
          other.__infAutoClosing = false;
        });
      }, 0);
    }, false);
  }

  function boot() {
    initInformaciones(document);
    bindAccordionSingleOpen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Soporte editor de temas (Shopify) — re-inicializar al recargar una sección
  document.addEventListener('shopify:section:load', function (e) {
    initInformaciones(e.target || document);
  });
})();

/* ---------- Wishlist / favoritos (req 2b) — localStorage por dispositivo ---------- */
(function () {
  'use strict';
  var KEY = 'pialu_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(list, handle) {
    return list.some(function (i) { return i.handle === handle; });
  }
  function itemFromBtn(btn) {
    var d = btn.dataset;
    return {
      handle: d.wlHandle,
      id: d.wlId,
      variant: d.wlVariant,
      title: d.wlTitle,
      url: d.wlUrl,
      image: d.wlImage,
      price: d.wlPrice,
      available: d.wlAvailable !== 'false'
    };
  }

  function toggle(btn) {
    var list = read();
    var handle = btn.dataset.wlHandle;
    if (!handle) return;
    if (has(list, handle)) {
      list = list.filter(function (i) { return i.handle !== handle; });
    } else {
      var item = itemFromBtn(btn);
      item.ts = (new Date()).getTime();
      list.unshift(item);
    }
    write(list);
    syncButtons();
    updateCount();
    renderPage();
  }

  function syncButtons(scope) {
    var list = read();
    (scope || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = has(list, btn.dataset.wlHandle);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-label', active ? 'Quitar de favoritos' : 'Añadir a favoritos');
      btn.setAttribute('title', active ? 'Quitar de favoritos' : 'Añadir a favoritos');
    });
  }

  var prevCount = null;
  function updateCount() {
    var n = read().length;
    var grew = prevCount !== null && n > prevCount;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
      if (grew) {
        el.classList.remove('wishlist-count--bump');
        void el.offsetWidth; // reflow: reinicia la animación
        el.classList.add('wishlist-count--bump');
      }
    });
    prevCount = n;
  }

  function cardHTML(item) {
    var price = item.price || '';
    var img = item.image
      ? '<img src="' + item.image + '" alt="' + (item.title || '') + '" loading="lazy">'
      : '';
    var atc = (item.variant && item.available)
      ? '<button type="button" class="wl-card__atc btn btn--primary btn--full" data-wl-atc="' + item.variant + '">Agregar al carrito</button>'
      : '<a class="wl-card__atc btn btn--secondary btn--full" href="' + item.url + '">Ver producto</a>';
    return '' +
      '<div class="wl-card" data-wl-card="' + item.handle + '">' +
        '<div class="wl-card__media">' +
          '<a href="' + item.url + '" class="wl-card__media-link">' + img + '</a>' +
          '<button type="button" class="wl-card__remove" data-wl-remove="' + item.handle + '" aria-label="Quitar de favoritos">&times;</button>' +
        '</div>' +
        '<a class="wl-card__title ff-heading" href="' + item.url + '">' + (item.title || '') + '</a>' +
        '<div class="wl-card__price ff-product-price">' + price + '</div>' +
        atc +
      '</div>';
  }

  function renderPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var page = grid.closest('[data-wishlist-page]') || document;
    var empty = page.querySelector('[data-wishlist-empty]');
    var list = read();
    if (!list.length) {
      grid.setAttribute('hidden', '');
      grid.innerHTML = '';
      if (empty) empty.removeAttribute('hidden');
      return;
    }
    if (empty) empty.setAttribute('hidden', '');
    grid.removeAttribute('hidden');
    grid.innerHTML = list.map(cardHTML).join('');
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    var original = btn.textContent;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function () {
      btn.textContent = '¡Añadido! ✓';
      // Avisar al tema (carrito, barra de recompensas, etc.)
      ['cart:refresh', 'cart:updated'].forEach(function (ev) {
        document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
      });
      setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
    }).catch(function () {
      btn.textContent = original; btn.disabled = false;
    });
  }

  function onClick(e) {
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) { e.preventDefault(); toggle(toggleBtn); return; }

    var removeBtn = e.target.closest('[data-wl-remove]');
    if (removeBtn) {
      e.preventDefault();
      var handle = removeBtn.dataset.wlRemove;
      write(read().filter(function (i) { return i.handle !== handle; }));
      syncButtons(); updateCount(); renderPage();
      return;
    }

    var atcBtn = e.target.closest('[data-wl-atc]');
    if (atcBtn) { e.preventDefault(); addToCart(atcBtn.dataset.wlAtc, atcBtn); return; }
  }

  function boot() {
    syncButtons();
    updateCount();
    renderPage();
    document.addEventListener('click', onClick);
    // Sincronizar entre pestañas
    window.addEventListener('storage', function (e) {
      if (e.key === KEY) { syncButtons(); updateCount(); renderPage(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    syncButtons(); updateCount(); renderPage();
  });
  // Re-sincronizar tras inyectar HTML dinámico (ej. popup de looks)
  document.addEventListener('pialu:refresh-wishlist', function () {
    syncButtons(); updateCount();
  });
})();

/* ---------- Req 2i · Slider de imágenes en las tarjetas de colección ---------- */
(function () {
  'use strict';

  // Pialu fix 2026-06-09: delegación a nivel de documento. Las tarjetas de
  // recomendación de la PDP se inyectan por AJAX (API Product Recommendations)
  // DESPUÉS de cargar la página y NO disparan DOMContentLoaded ni
  // shopify:section:load, así que un init por-tarjeta nunca corría en ellas
  // (flechas inertes; imágenes 2..N en data-src sin cargar). La delegación
  // funciona sea cual sea el momento de inyección, sin tocar el LCP: las
  // imágenes solo se cargan cuando el usuario interactúa con la tarjeta.

  function loadDeferred(slider) {
    if (!slider || slider.dataset.piLoaded === '1') return;
    slider.dataset.piLoaded = '1';
    slider.querySelectorAll('img[data-src]').forEach(function (img) {
      if (img.dataset.srcset) { img.setAttribute('srcset', img.dataset.srcset); img.removeAttribute('data-srcset'); }
      if (img.dataset.src) { img.setAttribute('src', img.dataset.src); img.removeAttribute('data-src'); }
    });
  }

  function updateArrows(slider) {
    var track = slider.querySelector('[data-pi-track]');
    if (!track) return;
    var prev = slider.querySelector('[data-pi-prev]');
    var next = slider.querySelector('[data-pi-next]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.hidden = track.scrollLeft <= 2;
    if (next) next.hidden = track.scrollLeft >= max;
  }

  // Flechas (delegado en document): carga diferida + scroll de una "página".
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-pi-next], [data-pi-prev]');
    if (!btn) return;
    var slider = btn.closest('[data-pi-slider]');
    var track = slider && slider.querySelector('[data-pi-track]');
    if (!track) return;
    e.preventDefault();
    e.stopPropagation();
    loadDeferred(slider);
    var dir = btn.hasAttribute('data-pi-next') ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
  });

  // Primer gesto (hover/touch) sobre una tarjeta: precarga sus imágenes.
  function onFirstGesture(e) {
    if (!e.target || !e.target.closest) return;
    var slider = e.target.closest('[data-pi-slider]');
    if (slider) loadDeferred(slider);
  }
  document.addEventListener('pointerover', onFirstGesture, { passive: true });
  document.addEventListener('touchstart', onFirstGesture, { passive: true });

  // Scroll/swipe del track (scroll no burbujea -> captura): carga + refresca flechas.
  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track || !track.matches || !track.matches('[data-pi-track]')) return;
    var slider = track.closest('[data-pi-slider]');
    if (!slider) return;
    loadDeferred(slider);
    window.requestAnimationFrame(function () { updateArrows(slider); });
  }, { passive: true, capture: true });

  // Estado inicial de las flechas para las tarjetas presentes...
  function refreshArrows(scope) {
    (scope || document).querySelectorAll('[data-pi-slider]').forEach(updateArrows);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refreshArrows(document); });
  } else {
    refreshArrows(document);
  }
  document.addEventListener('shopify:section:load', function (e) { refreshArrows(e.target || document); });

  // ...y para las tarjetas inyectadas por AJAX (recomendaciones de la PDP).
  if (window.MutationObserver) {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (!n || n.nodeType !== 1) continue;
          if (n.matches && n.matches('[data-pi-slider]')) updateArrows(n);
          if (n.querySelectorAll) n.querySelectorAll('[data-pi-slider]').forEach(updateArrows);
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* ---------- Req 1 · Página Looks: popup comprable ---------- */
(function () {
  'use strict';

  function esc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : s.replace(/"/g, '\\"'); }

  function openLook(btn) {
    var section = btn.closest('.looks-grid-section');
    if (!section) return;
    var id = btn.dataset.lookOpen;
    var tpl = section.querySelector('template[data-look-tpl="' + esc(id) + '"]');
    var modal = section.querySelector('[data-looks-modal]');
    var body = section.querySelector('[data-looks-body]');
    if (!tpl || !modal || !body) return;
    body.innerHTML = '';
    body.appendChild(tpl.content.cloneNode(true));
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.dispatchEvent(new CustomEvent('pialu:refresh-wishlist'));
  }

  function closeAll() {
    document.querySelectorAll('[data-looks-modal]').forEach(function (m) {
      m.hidden = true;
      var b = m.querySelector('[data-looks-body]');
      if (b) b.innerHTML = '';
    });
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    var original = btn.textContent;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function () {
      btn.textContent = '¡Añadido! ✓';
      ['cart:refresh', 'cart:updated'].forEach(function (ev) {
        document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
      });
      setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
    }).catch(function () { btn.textContent = original; btn.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-look-open]');
    if (openBtn) { e.preventDefault(); openLook(openBtn); return; }
    if (e.target.closest('[data-looks-close]')) { e.preventDefault(); closeAll(); return; }
    var atc = e.target.closest('[data-looks-atc]');
    if (atc) { e.preventDefault(); addToCart(atc.dataset.looksAtc, atc); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();

/* ---------- Req 5 · Aviso de stock (back in stock) ---------- */
(function () {
  'use strict';

  function currentVariantId() {
    // Lee la variante seleccionada del formulario de producto (Cornerstone usa [name="id"])
    var input = document.querySelector('form[action$="/cart/add"] [name="id"], product-form [name="id"], [data-product-form] [name="id"]');
    if (input && input.value) return input.value;
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : '';
  }

  function open(wrap) {
    var modal = wrap.querySelector('[data-bis-modal]');
    if (modal) { modal.hidden = false; document.body.style.overflow = 'hidden'; }
  }
  function close(wrap) {
    var modal = wrap.querySelector('[data-bis-modal]');
    if (modal) { modal.hidden = true; document.body.style.overflow = ''; }
  }

  function submit(form) {
    var endpoint = window.PIALU_BIS_ENDPOINT;
    var success = form.querySelector('[data-bis-success]');
    var error = form.querySelector('[data-bis-error]');
    var submitBtn = form.querySelector('.bis__submit');
    if (success) success.hidden = true;
    if (error) error.hidden = true;

    var payload = {
      email: (form.querySelector('[name="email"]') || {}).value || '',
      product_id: form.dataset.productId,
      product_title: form.dataset.productTitle,
      product_handle: form.dataset.productHandle,
      product_url: form.dataset.productUrl,
      variant_id: currentVariantId(),
      shop: window.Shopify && window.Shopify.shop ? window.Shopify.shop : location.host,
      ts: (new Date()).toISOString()
    };

    if (!endpoint) {
      // Garde-fou de cara al cliente (no exponer mensajes de dev). Solo aparece si el
      // endpoint queda vacío en Ajustes. Texto neutro orientado al usuario.
      if (error) { error.textContent = 'Escríbenos a contacto@pialu.pe y te avisamos cuando vuelva. ¡Gracias!'; error.hidden = false; }
      console.warn('[Pialu BIS] window.PIALU_BIS_ENDPOINT vacío. Pega la URL del endpoint en Ajustes > Pialú · Estilo junio. Payload:', payload);
      return;
    }

    if (submitBtn) submitBtn.disabled = true;
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('bad status');
      if (success) success.hidden = false;
      form.querySelector('[name="email"]').value = '';
    }).catch(function () {
      if (error) error.hidden = false;
    }).then(function () {
      if (submitBtn) submitBtn.disabled = false;
    });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-bis-open]');
    if (openBtn) { e.preventDefault(); open(openBtn.closest('[data-bis]')); return; }
    var closeBtn = e.target.closest('[data-bis-close]');
    if (closeBtn) { e.preventDefault(); close(closeBtn.closest('[data-bis]')); return; }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-bis-form]');
    if (form) { e.preventDefault(); submit(form); }
  });
})();

/* ---------- Corrección #7 · Carrusel cuadrado: arrastre manual + rotación rAF ----------
   Mejora progresiva: si este JS corre, toma el control (rAF + drag); si no, el marquee CSS
   sigue funcionando. No hace nada si el visitante prefiere reducir el movimiento (fallback
   scroll nativo del CSS). */
(function () {
  'use strict';

  function setupCarousel(section) {
    var viewport = section.querySelector('.scc__viewport');
    var track = section.querySelector('.scc__track');
    if (!viewport || !track || viewport.dataset.sccJs === '1') return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return; // dejar el fallback CSS de scroll nativo

    var drag = viewport.getAttribute('data-scc-drag') === 'true';
    var autoplay = viewport.getAttribute('data-scc-autoplay') === 'true';
    var pauseHover = viewport.getAttribute('data-scc-pause-hover') === 'true';
    if (!drag && !autoplay) return; // marquee CSS puro: nada que mejorar

    viewport.dataset.sccJs = '1';
    viewport.classList.add('scc__is-js');
    if (drag) viewport.classList.add('scc__viewport--draggable');

    var duration = parseFloat(viewport.getAttribute('data-scc-duration')) || 20; // seg. por media vuelta
    var half = 0;
    var speed = 0;
    function measure() {
      half = (track.scrollWidth / 2) || 0;
      speed = half > 0 ? half / duration : 0; // px/seg
    }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);

    var offset = 0, last = null, dragging = false, hovering = false, raf = null, pdown = false;

    function wrap() {
      if (half > 0) { offset = ((offset % half) + half) % half; }
    }
    function frame(ts) {
      if (last == null) last = ts;
      var dt = (ts - last) / 1000; last = ts;
      if (dt > 0.5) dt = 0; // pestaña inactiva: no saltar
      if (autoplay && !dragging && !pdown && !(pauseHover && hovering)) {
        offset += speed * dt;
      }
      wrap();
      track.style.transform = 'translateX(' + (-offset) + 'px)';
      raf = requestAnimationFrame(frame);
    }
    raf = requestAnimationFrame(frame);

    if (pauseHover) {
      viewport.addEventListener('mouseenter', function () { hovering = true; });
      viewport.addEventListener('mouseleave', function () { hovering = false; });
    }

    if (drag) {
      var startX = 0, startOffset = 0, moved = 0, pid = null;
      var DRAG_THRESHOLD = 6;
      viewport.addEventListener('pointerdown', function (e) {
        // No se captura el puntero aquí: un simple tap debe dejar navegar el <a>.
        // pdown pausa el autoplay para que la tesela quede estable durante el tap.
        pdown = true; dragging = false; moved = 0; startX = e.clientX; startOffset = offset; pid = e.pointerId;
      });
      viewport.addEventListener('pointermove', function (e) {
        if (!pdown) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > moved) moved = Math.abs(dx);
        if (!dragging && Math.abs(dx) > DRAG_THRESHOLD) {
          // Movimiento real → es un arrastre: ahora sí capturamos el puntero.
          dragging = true;
          viewport.classList.add('scc__is-grabbing');
          try { viewport.setPointerCapture(pid); } catch (_) {}
        }
        if (dragging) { offset = startOffset - dx; wrap(); }
      });
      function endDrag() {
        pdown = false;
        if (!dragging) return;
        dragging = false;
        viewport.classList.remove('scc__is-grabbing');
        try { viewport.releasePointerCapture(pid); } catch (_) {}
      }
      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      // Bloquear la navegación SOLO si hubo un arrastre real.
      viewport.addEventListener('click', function (e) {
        if (moved > DRAG_THRESHOLD) { e.preventDefault(); e.stopPropagation(); }
        moved = 0;
      }, true);
    }
  }

  function initCarousels(root) {
    (root || document).querySelectorAll('[data-section-type="square-collection-carousel"]').forEach(setupCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCarousels(document); });
  } else {
    initCarousels(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    initCarousels(e.target || document);
  });
})();

/* ---------- PDP · Igualar el corazón wishlist a la altura del botón ATC (cuadrado) ---------- */
/* CSS `aspect-ratio` no funciona cuando la altura viene de align-self:stretch
   (Chrome calcula el ancho desde el contenido). Fijamos width = altura medida. */
(function () {
  'use strict';
  function sizeSquares(scope) {
    (scope || document).querySelectorAll('.wishlist-btn--pdp').forEach(function (b) {
      var h = b.offsetHeight;
      if (h) { b.style.width = h + 'px'; }
    });
  }
  var raf;
  function schedule(scope) {
    if (raf) window.cancelAnimationFrame(raf);
    raf = window.requestAnimationFrame(function () { sizeSquares(scope); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(document); });
  } else {
    schedule(document);
  }
  // La fuente del botón puede cargar tarde y cambiar su altura.
  window.addEventListener('load', function () { schedule(document); });
  window.addEventListener('resize', function () { schedule(document); });
  document.addEventListener('shopify:section:load', function (e) { schedule(e.target || document); });
})();
